import { useState } from "react"
import { motion } from "motion/react"

import { Button, Input } from "@productlane/ui"

export const UrlInput = ({
	handleUrlSubmit,
	onChange,
	title = "Media URL",
	error,
	autoFocus = false,
}: {
	handleUrlSubmit: (url: string) => void
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	title?: string | null
	error?: string | null
	autoFocus?: boolean
}) => {
	const [url, setUrl] = useState("")

	return (
		<div className="flex w-full flex-col gap-2">
			{title && <p className="text-xs font-medium">{title}</p>}
			<div className="flex w-full flex-row gap-2">
				<Input
					name="media-url"
					type="text"
					variant={"outline"}
					placeholder="Enter media URL"
					value={url}
					onChange={(e) => {
						setUrl(e.target.value)
						onChange?.(e)
					}}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleUrlSubmit(url)
						}
					}}
					className="w-full bg-transparent text-xs outline-none"
					autoComplete="off"
					autoFocus={autoFocus}
				/>
				<Button
					onClick={() => handleUrlSubmit(url)}
					variant="default"
					className="w-min"
				>
					Submit
				</Button>
			</div>
			{error && (
				<motion.div
					initial={{ opacity: 0, y: -5 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -5 }}
					className="ml-1 text-left text-sm text-red-500"
				>
					{error}
				</motion.div>
			)}
		</div>
	)
}
